import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import ButtonModule from '../../../component-lib/components/button/button-module';
import CurrencyModule from '../../../component-lib/components/currency/currency.module';
import { NumberInputModule } from '../../../component-lib/components/forms/number-input/number-input.module';
import { ModalModule } from '../../../component-lib/components/modal/modal.module';
import { ChargingCardInputComponent } from './charging-card-input.component';
import { ChargingCardInputMapper } from './charging-card-input.mapper';
import { ChargingCardInputService } from './charging-card-input.service';

@NgModule({
  declarations: [ChargingCardInputComponent],
  imports: [CommonModule, NumberInputModule, TranslateModule, ButtonModule, ModalModule, CurrencyModule, FormsModule],
  exports: [ChargingCardInputComponent],
  providers: [ChargingCardInputService, ChargingCardInputMapper],
})
export class ChargingCardInputModule {}
